function getOrderOnlineLink(title) {
  const linkMap = {
    "ablo-abbeydale": "N/A",
    "ablo-north-east-32nd-ave-mcknight": "N/A",
    "ablo-coventry-drive": "N/A",
    "ablo-village-square": "N/A",
    "ablo-braeside": "N/A",
    "ablo-lendrum": "N/A",
    "ablo-macewan": "N/A",
    "ablo-westbrook": "N/A",
    "ablo-erinwoods": "N/A",
  };
  
  return linkMap[title] || `https://orders.iorders.online/${title}`;
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. ABLO ABBEYDALE
      {
        profile: {
          id: 123,
          restaurant_name: "Ablo Abbeydale Calgary",
          title: "ablo-abbeydale",
          address: "826 68 St NE #5, Calgary, AB T2A 6X7",
          phone: "+1 (403) 273-2256",
          available_days: [
            {id: 1746, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1747, day: 'MONDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1748, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1749, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1750, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1751, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '23:00:00', order_mode: 1},
            {id: 1752, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '23:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.05960613907103",
          lng: "-113.9332008201283",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //2. ABLO - North East 32nd Ave & McKnight
      {
        profile: {
          id: 124,
          restaurant_name: "Ablo Northeast Calgary",
          title: "ablo-north-east-32nd-ave-mcknight",
          address: "1725 32 Ave NE #114, Calgary, AB T2E 7C8",
          phone: "+1 (403) 234-7082",
          available_days: [
            {id: 1753, day: 'SUNDAY', opening_time: 'CLOSED', closing_time: 'CLOSED', order_mode: 1},
            {id: 1754, day: 'MONDAY', opening_time: '11:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1755, day: 'TUESDAY', opening_time: '11:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1756, day: 'WEDNESDAY', opening_time: '11:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1757, day: 'THURSDAY', opening_time: '11:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1758, day: 'FRIDAY', opening_time: '11:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1759, day: 'SATURDAY', opening_time: '12:00:00', closing_time: '19:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.08071785505657",
          lng: "-114.01728115117798",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //3. ABLO - COVENTRY DRIVE
      {
        profile: {
          id: 125,
          restaurant_name: "Ablo Coventry Drive Calgary",
          title: "ablo-coventry-drive",
          address: "790 Coventry Dr NE #131, Calgary, AB T3K 4K4",
          phone: "+1 (403) 226-7082",
          available_days: [
            {id: 1760, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1761, day: 'MONDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1762, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1763, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '23:00:00', order_mode: 1},
            {id: 1764, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '23:00:00', order_mode: 1},
            {id: 1765, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1},
            {id: 1766, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.158149947539876",
          lng: "-114.04288932851058",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //4. ABLO - VILLAGE SQUARE
      {
        profile: {
          id: 126,
          restaurant_name: "Ablo Village Square Calgary",
          title: "ablo-village-square",
          address: "2640 52 St NE #115, Calgary, AB T1Y 3R6",
          phone: "+1 (403) 293-2256",
          available_days: [
            {id: 1767, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1768, day: 'MONDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1769, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1770, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1771, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1772, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1773, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.07529886143506",
          lng: "-113.95673038974218",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //5. ABLO - BRAESIDE
      {
        profile: {
          id: 127,
          restaurant_name: "Ablo Braeside Calgary",
          title: "ablo-braeside",
          address: "11140 Braeside Dr SW #25a, Calgary, AB T2W 1C3",
          phone: "+1 (403) 251-2255",
          available_days: [
            {id: 1774, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1775, day: 'MONDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1776, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1777, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1778, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1779, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1},
            {id: 1780, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "50.95384178318856",
          lng: "-114.10504235969873",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //6. ABLO - LENDRUM
      {
        profile: {
          id: 128,
          restaurant_name: "Ablo Lendrum Edmonton",
          title: "ablo-lendrum",
          address: "5854 111 St NW, Edmonton, AB T6H 3G1",
          phone: "+1 (780) 439-2256",
          available_days: [
            {id: 1781, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1782, day: 'MONDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1783, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1784, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1785, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1786, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1},
            {id: 1787, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "53.4959088320752",
          lng: "-113.51798322434959",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //7. ABLO - MACEWAN
      {
        profile: {
          id: 129,
          restaurant_name: "Ablo Macewan Edmonton",
          title: "ablo-macewan",
          address: "860 119 St SW, Edmonton, AB T6W 0J1",
          phone: "+1 (780) 433-2258",
          available_days: [
            {id: 1788, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1789, day: 'MONDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1790, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1791, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1792, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1793, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1},
            {id: 1794, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '00:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "53.425557429065705",
          lng: "-113.52930457391548",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //8. ABLO - WESTBROOK
      {
        profile: {
          id: 130,
          restaurant_name: "Ablo Westbrook Calgary",
          title: "ablo-westbrook",
          address: "1200 37 Street SW Unit 21, Calgary, AB T3C 1S2",
          phone: "+1 (403) 242-2256",
          available_days: [
            {id: 1795, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '20:00:00', order_mode: 1},
            {id: 1796, day: 'MONDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1797, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1798, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1799, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1800, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1801, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.04298908398774",
          lng: "-114.13909585448276",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
      //8. ABLO - WESTBROOK
      {
        profile: {
          id: 131,
          restaurant_name: "Ablo Erinwoods Calgary",
          title: "ablo-erinwoods",
          address: "3565 52 St. SE, Calgary, AB T2B 3R3",
          phone: "+1 (403) 452-4788",
          available_days: [
            {id: 1802, day: 'SUNDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1803, day: 'MONDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1804, day: 'TUESDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1805, day: 'WEDNESDAY', opening_time: '10:00:00', closing_time: '21:00:00', order_mode: 1},
            {id: 1806, day: 'THURSDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1807, day: 'FRIDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1},
            {id: 1808, day: 'SATURDAY', opening_time: '10:00:00', closing_time: '22:00:00', order_mode: 1}
          ],
          close_restaurent: false,
          disable_takeout_restaurent: false,
          disable_delivery_restaurent: false,
          lat: "51.022857652036365",
          lng: "-113.9581751081076",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        }
      },
    ]
  },
  message: "successful response"
};

export default storeDetails;
